import type { ReactNode } from 'react';
import { Icon } from './Icon';

/** Empty state with the printed-layers motif. */
export function EmptyState({
  title,
  children,
  action,
}: {
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      <div className="emptyart" aria-hidden="true" />
      <h2>{title}</h2>
      {children ? <p>{children}</p> : null}
      {action}
    </div>
  );
}

export function ErrorBox({
  title,
  detail = 'O servidor não respondeu. Seus dados estão salvos.',
  onRetry,
}: {
  title: string;
  /** The board's reassurance line ("Os pedidos continuam salvos."). */
  detail?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="errorbox" role="alert">
      <div className="ic">
        <Icon name="alert" size={26} />
      </div>
      <h2>{title}</h2>
      <p className="muted">{detail}</p>
      {onRetry ? (
        <button type="button" className="btn" onClick={onRetry}>
          Tentar de novo
        </button>
      ) : null}
    </div>
  );
}

export function Skeleton({ rows = 2, height = 56 }: { rows?: number; height?: number }) {
  return (
    <div className="col" style={{ gap: 10, padding: '12px 18px 18px' }} aria-hidden="true">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="skel" style={{ height }} />
      ))}
    </div>
  );
}

export function Alert({
  tone = 'info',
  children,
}: {
  tone?: 'info' | 'err' | 'warn' | 'ok';
  children: ReactNode;
}) {
  const icon = tone === 'ok' ? 'check' : tone === 'warn' ? 'lock' : 'alert';
  return (
    <div
      className={tone === 'info' ? 'alert' : `alert ${tone}`}
      role={tone === 'err' ? 'alert' : 'note'}
    >
      <Icon name={icon} size={22} className="ic" />
      <div className="sm">{children}</div>
    </div>
  );
}
